var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"Router"}},[_c('v-overlay',{attrs:{"opacity":"0.3","z-index":"10"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }